module.exports = __webpack_public_path__ + "static/media/BovExo_template_suplementos.04282cda.xlsx";